window.arjoWebinarArticleModule =
  window.arjoWebinarArticleModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };
    const classNamePrefix = 'arjo-t-webminar-article';

    const handleAreaDropdownChange = (scheduleDom, scheduleDropdownId) => {
      const dropdownDom = scheduleDom.querySelector(`[data-dropdown-id='${scheduleDropdownId}']`);
      const topLabel = dropdownDom.querySelector('.arjo-m-dropdown__label');
      const optionContainer = dropdownDom.querySelector('.arjo-m-dropdown__options');

      const id = dropdownDom.dataset.dropdownId;
      const name = dropdownDom.dataset.name;

      const setupChangeHandler = () => {
        const options = optionContainer.querySelectorAll('.arjo-m-dropdown__options-input');

        [].forEach.call(options, (option) => {
          option.addEventListener('change', () => window.arjoDropdownJs.changeEventHandler(option));

          if (option.checked) {
            window.arjoDropdownJs.changeEventHandler(option);
          }
        });
      };

      const createOption = ({ value, label, hidden, turnOffAutocomplete, otherInfo, checked }, index) => {
        let autoCompleteAttr = turnOffAutocomplete ? `autocomplete="off"` : '';
        let checkedAttr = checked ? 'checked' : '';
        let otherInfoAttr = otherInfo ? `data-other-info="${otherInfo}"` : '';

        let labelHtml = `
                <label 
                  class="arjo-m-dropdown__options-label"
                  for="${id}-${name}-${index}">
                  ${label}
                </label>
              `;

        let inputHtml = `
                <input
                    id="${id}-${name}-${index}"
                    class="arjo-m-dropdown__options-input"
                    name="${id}-${name}"
                    type="radio"
                    value="${value}"
                    data-label="${label}"
                    ${autoCompleteAttr}
                    ${checkedAttr}
                    ${otherInfoAttr}
                  />`;

        return `
                ${inputHtml}
                ${hidden ? '' : labelHtml}
              `;
      };

      const setOptions = (options) => {
        optionContainer.innerHTML = '';

        [].forEach.call(options, (item, index) => {
          optionContainer.innerHTML += createOption(item, index);
        });

        setupChangeHandler();

        const checkedOption = options.find((x) => x.checked);

        if (checkedOption) {
          const checkedRadio = optionContainer.querySelector('input:checked');

          topLabel.querySelector('.arjo-m-dropdown__label-text').innerText = checkedOption.label;
          checkedRadio.dispatchEvent(
            new UIEvent('change', {
              view: window,
              bubbles: true,
            })
          );
        }

        if (options.length === 1) {
          dropdownDom.classList.add('single-option');
        } else {
          dropdownDom.classList.remove('single-option');
        }
      };

      return { setOptions };
    };

    const handleIFrames = (webinarRegister) => {
      const iFrameLoadHandler = (frame) => {
        try {
          frame.height = frame.contentWindow.document.documentElement.scrollHeight;
        } catch {
          window.addEventListener("message", (e) => {
            if (e?.data?.includes?.("iframeHeight")) {
              let height = e.data.split(":")[1];

              frame.height = parseInt(height);
            }
          });
        }
      };

      var frames = webinarRegister.querySelectorAll("iframe");

      [].forEach.call(frames, (frame) => {
        frame.addEventListener("load", () => iFrameLoadHandler(frame));
        iFrameLoadHandler(frame);
      });
    };


    const setUp = () => {
      const els = [...document.querySelectorAll(`.${classNamePrefix}`)];
      els.forEach((el) => {
        const scheduleDom = el.querySelector(`.${classNamePrefix}__schedule`);

        if (scheduleDom) {
          const scheduleDropdownId = scheduleDom.dataset.scheduleDropdownId;

          const scheduleData = scheduleDom.querySelector(`.${classNamePrefix}__schedule-data`);
          const areaDropdownWrapper = scheduleDom.querySelector(`.${classNamePrefix}__area-dropdown`);
          const scheduleDropdownWrapper = scheduleDom.querySelector(`.${classNamePrefix}__schedule-dropdown`);
          const registerButtonDom = scheduleDom.querySelector('.arjo-a-link');
          const scheduleDateDom = scheduleDom.querySelector(`.${classNamePrefix}__schedule-date`);

          scheduleDropdownWrapper && scheduleDropdownWrapper.addEventListener('change', (e) => {
            registerButtonDom && registerButtonDom.setAttribute('href', e.target.value);
            scheduleDateDom && (scheduleDateDom.innerText = e.target.dataset.otherInfo);
          });

          if(scheduleData) {
            const data = scheduleData && JSON.parse(scheduleData.innerText);

            areaDropdownWrapper && areaDropdownWrapper.addEventListener('change', (e) => {
              if (data[e.target.value]) {
                handleAreaDropdownChange(scheduleDom, scheduleDropdownId).setOptions(data[e.target.value]);
              }
            });
          }
        }

        handleIFrames(el);
      });
    };

    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };
    return { init };
  })();

window.addEventListener('load', window.arjoWebinarArticleModule.init);
